<template>
  <main class="sg d-flex flex-column flex-fill" role="main">
    <Header :title="title" :tagline="tagline"></Header>
    <router-view
      name="nav"
      :navData="navData"
      :currentNavTab="currentNavTab"
      @update-current-nav-tab="updateCurrentNavTab"
    ></router-view>
    <section id="sg-main" class="flex-grow-1 py-5 px-lg-5">
      <div class="container">
        <div class="row">
          <article class="offset-xl-1 col-xl-10 offset-xxl-2 col-xxl-8">
            <router-view
              @update-title="updateTitle"
              @update-tagline="updateTagline"
              @update-nav="updateNav"
              :currentNavTab="currentNavTab"
            ></router-view>
          </article>
        </div>
      </div>
    </section>
    <Pager/>
    <Footer/>
  </main>
</template>

<script>
import Header from "@/components/Header.vue";
import Pager from "@/components/Pager.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Body",
  components: {
    Header,
    Pager,
    Footer
  },
  data() {
    return {
      title: "",
      tagline: "",
      navData: {},
      currentNavTab: ""
    };
  },
  methods: {
    updateTitle: function(newTitle) {
      this.title = newTitle;
    },
    updateTagline: function(newTagline) {
      this.tagline = newTagline;
    },
    updateNav: function(newNav) {
      this.navData = newNav;
    },
    updateCurrentNavTab: function(newCurrentNavTab) {
      this.currentNavTab = newCurrentNavTab;
    }
  }
};
</script>